import styled from "styled-components";


export const Wrapper = styled.div`

`
export const TimerContent = styled.div`
font-size: var(--general-page-header-font-size);
color: var(--font-color-blue002e5c);
width: 50px;
`